<template>
    <div :class="centered ? 'centeredWrapper' : 'classicWrapper'">
        <div class="tableWrapper">
            <b-table hover
                     :items="objects"
                     :fields="objectsFieldName"
                     @row-clicked="getProperties"
                     class="table"
                     sticky-header
                     selectable
                     borderless
                     select-mode="single"
                     :busy="isBusy">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{ $t('Loading') }}</strong> <!--  Chargement... -->
                    </div>
                </template>
            </b-table>
            <b-table hover
                     :items="selectedObjectProperties"
                     :fields="propertiesFieldName"
                     class="table"
                     sticky-header
                     borderless
                     :busy="isBusy">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{ $t('Loading') }}</strong> <!--  Chargement... -->
                    </div>
                </template>
                <template v-slot:cell(labelCheck)="data" class="table">
                    <span class="row">
                        <span class="rowTxt">{{ data.item.label }}</span>
                        <b-form-checkbox v-model="data.item.ToolTip"
                                         :disabled="getCheckStatus(data.item)"
                                         class="rowCheck">
                        </b-form-checkbox>
                    </span>
                </template>
            </b-table>
        </div>
        <b-button variant="success" class="rounded-0 border-0 btnSave" @click="updateTooltip">
            <div v-show="!isBusySaving">{{ $t('Save1') }}</div> <!-- Enregistrer -->
            <div class="loaderWrapper" v-if="isBusySaving">
                <b-spinner class="infoSpinner" label="Large Spinner" type="grow"></b-spinner>
                <b-spinner class="infoSpinner second" label="Large Spinner" type="grow"></b-spinner>
                <b-spinner class="infoSpinner third" label="Large Spinner" type="grow"></b-spinner>
            </div>
        </b-button>
    </div>
</template>

<script lang="ts">

    import { Component, Vue, Prop } from 'vue-property-decorator';
    import axiosManager from '@/components/plugins/axiosGlobal/axiosManager';
    import { State, namespace } from 'vuex-class';
    import map from '@/types/map/type-map'
    import locales from './locales/InfoWindowParameters.json';

    const CartoModule = namespace("CartoMod");

    @Component({
        name: 'info-window-parameters',
        i18n : { messages : locales }
    })
    export default class InfoWindowParameters extends Vue {

        @CartoModule.State
        private map!: map;

        private selectedObjectProperties: string[] = [];
        private listObjects: string[] = [];
        private isBusy: boolean = false;
        private isBusySaving: boolean = false;

        get centered() {
            if (this.map.mapApi == 1) {
                return true
            }
            else {
                return false
            }
        }

        get objects() {
            return this.listObjects;
        }

        get objectsFieldName() {
            return [{key : 'ObjectType.Name', label : this.$t('HeritageObjects').toString()}]; // 'Objets Patrimoine'
        }

        get propertiesFieldName() {
            return [{ key: 'labelCheck', label: this.$t('Properties').toString()}] //  'Propriétés'
        }

        mounted() {
            //var parseString = require('xml2js').parseString;

            this.isBusy = true;

            this.$Direct.postAwaitable("carto/getTooltip", null).then((result) => {
                var newItem;
                for (let item of result) {
                    newItem = {
                        ObjectType: {
                            Name: item.ObjectType.Name,
                            Index : item.ObjectType.Index
                        },
                        Properties: item.Properties
                    }
                    this.listObjects.push(newItem)
                }
                this.isBusy = false;
                //var XmlDoc = new DOMParser().parseFromString(result, 'text/xml')
                //console.log(this.xmlToJson(XmlDoc))

            })
            //var xhttp = new XMLHttpRequest();
            //xhttp.onreadystatechange = function () {
            //    if (this.readyState == 4 && this.status == 200) {
            //        console.log(xhttp.responseText)
            //    }
            //};
            //xhttp.open('POST', 'Dcx3ServerSide/api/carto/getTooltip', true);
            //xhttp.send();
        }

        updateTooltip() {
            this.isBusySaving = true;
            this.$Direct.postAwaitable("carto/updateTooltip", this.listObjects).then(() => {
                this.$emit('savedTooltipParameters');
                this.isBusySaving = false;
            })
        }

        getCheckStatus(item: any) {
            console.log(item)
            if (item.name === 'Name')
                return true
            else
                return false
        }

        getProperties(item: any, index: any, event: any) {
            this.selectedObjectProperties = item.Properties;
        }
    }
</script>

<style scoped>

    .classicWrapper {
        width: 500px;
        position: relative;
        background-color: white;
        z-index: 99;
    }

    .centeredWrapper {
        width: 60%;
        position: absolute;
        background-color: white;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
    }

    .tableWrapper {
        display: flex;
        width: 100%;
        text-align: left;
    }

    .row {
        width: 100%;
    }

        .row .rowTxt {
            width: 80%;
            text-align: left;
            margin: auto;
        }

    .btnSave {
        position: relative;
        margin: 5px;
        height: 35px;
        width: 125px;
        overflow: hidden;
    }

    .loaderWrapper {
        height: 35px;
        width: 125px;
        margin: auto;
        overflow: hidden;
    }

    .infoSpinner {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        display: block;
        width: 3rem;
        height: 3rem;
        animation-duration: 2000ms;
        animation-timing-function: ease-out;
    }

    .second {
        animation-delay: 500ms;
        animation-timing-function: ease-out;
        color: #93c01f;
    }

    .third {
        animation-delay: 1000ms;
        animation-timing-function: ease-out;
        color: #17a2b8;
    }
</style>